import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import { SuppressStatusComponent } from '../ControlGroups/SuppressStatus.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {BillingAddressComponent} from '../../components/ControlGroups/BillingAddress.component';
import {ContactDetailsComponent} from '../../components/ControlGroups/ContactDetails.component';
import {PricingComponent} from '../../components/ControlGroups/Pricing.component';
import {SalesAndDeliveryDetailsComponent} from '../../components/ControlGroups/SalesAndDeliveryDetails.component';
import {CoolerDetailsComponent} from '../../components/ControlGroups/CoolerDetails.component';
import {FountainDetailsComponent} from '../../components/ControlGroups/FountainDetails.component';
import {VendorDetailsComponent} from '../../components/ControlGroups/VendorDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';
import { CustomerRequirementsComponent } from '../ControlGroups/CustomerRequirements.component';
import BaseNewOutletRequestComponent from 'src/app/baseclasses/BaseNewOutletRequest.component';

@Component({
  selector: 'my-createfullservice-customer-request',
  templateUrl: './CreateFullServiceCustomerRequest.component.html'
})
export class CreateFullServiceCustomerRequestComponent extends BaseNewOutletRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;
    
    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(SuppressStatusComponent) suppressStatusComponent: SuppressStatusComponent;
    @ViewChild(CustomerRequirementsComponent) customerRequirementsComponent: CustomerRequirementsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(BillingAddressComponent) billingAddressComponent: BillingAddressComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(PricingComponent) pricingComponent: PricingComponent;
    @ViewChild(SalesAndDeliveryDetailsComponent) salesAndDeliveryComponent: SalesAndDeliveryDetailsComponent;
    @ViewChild(CoolerDetailsComponent) coolerDetailsComponent: CoolerDetailsComponent;
    @ViewChild(FountainDetailsComponent) fountainDetailsComponent: FountainDetailsComponent;
    @ViewChild(VendorDetailsComponent) vendorDetailsComponent: VendorDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    showEquipmentInstallSections: boolean;
    showCustomerRequirements: boolean;
    showSuppressCustomer: boolean;
    constructor() 
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        this.userInfoComponent.onSalesOfficeChange.subscribe((x: any) => this.userInfoSalesOfficeChange(x));
    }

    ngAfterViewInit() {
        super.subscribeToOverallAccountCopyMethodsInContactDetailsSection();
        super.subscribeToOverallAccountCopyMethodsInBillingAddressSection();
        super.ngAfterViewInit();
    }

    userInfoSalesOfficeChange(salesOffice: ent.SalesOffice) {

        this.salesAndDeliveryComponent.setSalesOffice(salesOffice, null);
    }

    getRequestTypeID(){
        return enums.RequestTypeEnum.FullServiceCustomer;
    }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.FullServiceCustomer,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            SuppressInfo: this.suppressStatusComponent.suppressInfo,
            ContactInfos: this.contactDetailsComponent.contactGridComponent.records,
            PricingInfo: this.pricingComponent.pricingInfo,
            SalesAndDeliveryInfo: this.salesAndDeliveryComponent.salesAndDeliveryInfo,
            BillingInfo: this.billingAddressComponent.billingInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        this.requestToSave.GeneralInfo.BusinessTypeID = enums.BusinessTypeEnum.FullService;

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        util.RequestUtil.LoadSerialNumbers(this.requestToSave, this.generalDetailsComponent);

        this.requestToSave.SalesAndDeliveryInfo.GoodsReceivingHoursStartString = this.salesAndDeliveryComponent.getStartTime();
        this.requestToSave.SalesAndDeliveryInfo.GoodsReceivingHoursEndString = this.salesAndDeliveryComponent.getEndTime();
        
        if (this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall)
        {
            this.requestToSave.CustomerRequirementInfo = this.customerRequirementsComponent.customerRequirementInfo;

            this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.customerRequirementsComponent.dayOfWeekMultiSelectComponent, enums.DayType.CustomerNotAvailable);

            this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityStartString = this.customerRequirementsComponent.getStartTime();
            this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityEndString = this.customerRequirementsComponent.getEndTime();
            this.requestToSave.VendorLineItems = this.vendorDetailsComponent.vendorLineItemGrid.lineItems;
            // this.requestToSave.FountainLineItems = this.fountainDetailsComponent.fountainLineItemGrid.lineItems;
            // this.requestToSave.CoolerLineItems = this.coolerDetailsComponent.coolerLineItemGrid.lineItems;

            // this.requestToSave.CoolerInfo = this.coolerDetailsComponent.coolerInfo;
            // this.requestToSave.FountainInfo = this.fountainDetailsComponent.fountainInfo;
            this.requestToSave.VendorInfo = this.vendorDetailsComponent.vendorInfo;

            this.requestToSave.VendorInfo.EquipmentLocations = this.vendorDetailsComponent.equipmentLocationsComponent.getEquipmentLocations();
        }
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.VendPackageLineItems = this.pricingComponent.vendPackageLineItemGrid.lineItems;
        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        if (util.AddressUtil.isAddressPopulated(this.billingAddressComponent.billingInfo.Address)){
            this.requestToSave.Addresses.push(this.billingAddressComponent.billingInfo.Address);
        }

        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.deliveryDaysDayOfWeekMultiSelectComponent, enums.DayType.Delivery);
        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.callDaysDayOfWeekMultiSelectComponent, enums.DayType.Call);

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onIncludeEquipmentInstallChanged(checked: boolean){
        this.showEquipmentInstallSections = checked;

        this.showCustomerRequirements = checked;
    }

    onincludeOwnershipChangeChanged(checked: boolean) {
        this.showSuppressCustomer = checked;
    }

    getDistributionChannel(): string {
        return Constants._DISTRIBUTION_CHANNEL_FSV;
    }


}